'use strict';

module.exports = function ( time ) {
    var min, hour;

    hour = Math.floor(time / 3600);
    time -= hour * 3600;
    min = Math.floor(time / 60);
    time -= 60 * min;

    hour = hour || '0';
    if ( min ) {
        min = min > 9 ? min : '0' + min;
    } else {
        min = '00';
    }
    time = time > 9 ? time : '0' + time;

    return hour + ':' + min + ':' + time;
};
